import { render, staticRenderFns } from "./SaleTypes.vue?vue&type=template&id=f27fd068"
import script from "./SaleTypes.vue?vue&type=script&lang=ts"
export * from "./SaleTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f27fd068')) {
      api.createRecord('f27fd068', component.options)
    } else {
      api.reload('f27fd068', component.options)
    }
    module.hot.accept("./SaleTypes.vue?vue&type=template&id=f27fd068", function () {
      api.rerender('f27fd068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SaleTypes.vue"
export default component.exports